import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject,  ElementRef, Renderer2, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  isYearlyChecked: boolean = true;
  formSection: boolean = true;
  thankSection: boolean = false;
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  contactUsSection: String;
  monthfinalSection: boolean = false;
  YearlyfinalSection: boolean = true;
  country: string;
  encodedData: any;
  decodedData: any;
  paymentModeOption: any;
  finalAmmount: any;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef, private renderer: Renderer2,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormSubjects': ['', Validators.required],
      'contactFormMessage': ['', Validators.required],
      'contactphoneNo': ['', Validators.required],
      'NatureBusinessType': ['', Validators.required],
      'DesignationTypes': ['', Validators.required],
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("country-trinka") == null || localStorage.getItem("country-trinka") == "") {
        this.loadGeoAPIScript();
      }
    }
    this.titleService.setTitle('Trinka定價-由AI驅動的正式寫作助手');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka個人使用免費。 企業可以以最大的價值受益於強大的寫作功能。 學術和技術寫作的唯一工具。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '免費文法檢查工具，用於學術和技術寫作的文法檢查工具，學術寫作助手，技術寫作助手，高級文法檢查，自動文法檢查工具，自動文法校正' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka定價-由AI驅動的正式寫作助手' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka個人使用免費。 企業可以以最大的價值受益於強大的寫作功能。 學術和技術寫作的唯一工具。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/pricing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/pricing' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    this.country = localStorage.getItem("country-trinka") ? localStorage.getItem("country-trinka") : "en";
      // console.log(this.country);
      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.getPlans(this.encodedData,1).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.decodedData = resp['data']
            this.decodedData.sort((a, b) => a.index - b.index);
            this.paymentModeOption = this.decodedData;
            console.log("Country is: ",this.country);
            // console.log(this.decodedData);
            // console.log(this.decodedData[2].final_amount);
            // this.onSelectionPlan(this.paymentModeOption[2], 2)
            var annualAmount = this.decodedData[3].final_amount;
            this.finalAmmount = annualAmount / 12;
            // console.log(this.finalAmmount);
          }
        });
      });
      ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  sectionValue(section: string) {
    this.contactUsSection = section
    this.formSection = true;
    this.thankSection = false;
  }

  sendContactUsForm() {
    if (this.contactForm.valid) {
      var query =this.contactForm.value.NatureBusinessType + "||" + this.contactForm.value.contactFormSubjects + "||" + this.contactForm.value.contactFormMessage + "||" + this.contactForm.value.contactFormName + "||" + this.contactForm.value.DesignationTypes + "||" + this.contactForm.value.contactphoneNo
      this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query, this.router.url).subscribe(result => {
        this.formSection = false;
        this.thankSection = true;
        // this.toastr.success("Thanks! We will contact you shortly.")
        this.contactForm.reset();
      }, error => {
        this.toastr.warning("Something went wrong!")
      })
    } else {
      this.validateAllFormFields(this.contactForm)
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  monthyPricing(){
    this.monthfinalSection = true;
    this.YearlyfinalSection = false;
  }
  yearlyPricing(){
    this.monthfinalSection = false;
    this.YearlyfinalSection = true;
  }
//   scroll(el: HTMLElement) {
//     el.scrollIntoView();
// }
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const element = this.el.nativeElement.querySelector('.table-container');
    const rect = element.getBoundingClientRect();

    if (rect.top <= 0) {
      // Add your CSS class when the element touches the top of the page
      this.renderer.addClass(element, 'sticky-class');
    } else {
      // Remove the CSS class when the element is not touching the top of the page
      this.renderer.removeClass(element, 'sticky-class');
    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
